import { VueConstructor } from 'vue/types/umd';
import moment, { MomentInput } from 'moment';

const dateFormatFilter = (value: MomentInput, format = 'YYYY-MM-DD HH:mm') => {
  return moment(value).format(format);
};

export function useDateFormatFilter(app: VueConstructor) {
  app.filter('dateFormat', dateFormatFilter);
}

export default dateFormatFilter;
